export const ACTIVE_MOMO_DEPOSIT_KEY = 'btp_active_momo_deposit_id';
export const MOMO_PENDING_SECONDS = 10 * 60;